export const paymentMethods = [
  {
    name: "wallet",
    icon: "https://www.kindpng.com/picc/m/580-5809740_white-wallet-logo-png-wallet-icon-ios-transparent.png",
    title: "Wallet",
  },
  {
    name: "credit",
    icon: "https://media.istockphoto.com/vectors/safe-payment-logo-template-designs-vector-illustration-vector-id1215256045?k=20&m=1215256045&s=612x612&w=0&h=IQX0a8uPVKSTGfJyWtWv3eXAMk4LTuQSmMtNqv_IBZs=",
    title: "Credit",
  },
  {
    name: "webirr_cbe",
    icon: "https://www.ethiopiatrustfund.org/wp-content/uploads/2018/09/cbe-logo.png",
    title: "CBE",
  },
  {
    name: "USDCredit",
    icon: "https://www.ledger.com/wp-content/uploads/2021/05/usdc-logo.png",
    title: "USD Credit",
  },
  {
    name: "kacha",
    icon: "",
    title: "Kacha Credit",
  },
];
